import script from "./UserGeneratedResourceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserGeneratedResourceCard.vue?vue&type=script&setup=true&lang=js"

import "./UserGeneratedResourceCard.vue?vue&type=style&index=0&id=47697563&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47697563"]])

export default __exports__